import React from 'react';
import { classNames } from '../../Services/helpers';
import Dropdown from '../Dropdown';
import Loading from '../Loading';
import Text from '../Formatting/Text';

const Section = ({
    title,
    subtitle,
    className,
    children,
    scrollY,
    maxH,
    menu,
    menuIcon,
    menuDisabled,
    menuLoading,
    options,
    optionsVal,
    optionsCallback,
    onClick,
    button,
    isLoading
}) => {

    return <div className={classNames('pt-5 first:pt-0', className)}>

        <div className="flex flex-row justify-between items-center mb-2">
            {title && <h3 className="text-lg font-bold text-brand grow shrink-0"
                onClick={() => onClick && onClick()}
            >
                {title}
                {isLoading && <Loading className="ml-2" />}
            </h3>}
            {options && <Options {...{options, optionsCallback, optionsVal}} />}
            {menu && <Dropdown className="-mt-2" icon={menuIcon} options={menu} disabled={menuDisabled} loading={menuLoading} />}
            {button && button}
        </div>

        {subtitle && <h4 className="text-sm text-muted mb-2 -mt-2"
            onClick={() => onClick && onClick()}
        >
            <Text text={subtitle} />
        </h4>}

        <div className={classNames(scrollY && 'overflow-y-auto', maxH)}>
            {children}
        </div>

    </div>
}

const Options = ({options, optionsCallback, optionsVal}) => {
    return <div className="grid grid-flow-col auto-cols-max divide-x grow-0 shrink-0">
        {options.map(opt => {
            return <div key={opt} className="px-2">
                <button
                    className={classNames(
                        'text-sm',
                        optionsVal === opt ? 'text-brand font-bold' : 'text-muted font-medium'
                    )}
                    onClick={() => optionsCallback(opt)}
                >
                    {opt}
                </button>
            </div>
        })}
    </div>
}

const Sections = ({children, className, spacing = 'gap-y-4 mb-8', divider = false}) => {
    return <div className={classNames(
        'flex flex-col',
        spacing,
        divider && 'divide-y',
        className
    )}>
        {children}
    </div>
}

export default Section;

export {
    Sections,
}
